let inject = ['$q', '$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService', '$httpParamSerializerJQLike'];

class BlogService {
    constructor($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService, $httpParamSerializerJQLike) {
        this.$q = $q;
        this.$http = $http;
        this.ngAuthSettings = ngAuthSettings;
        this.AuthTokenFactory = AuthTokenFactory;
        this.SharedService = SharedService;
        this.SessionService = SessionService;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    }


    getPosts(params){
      return this.$q((resolve, reject) => {
        this.$http({
          method: 'GET',
          url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getArticles,
          cache : true,
          params: params
        }).then((response) => {
          resolve(response.data);
        }, (reason) => {
          reject(reason);
        });
      });
    }
    getRelatedPosts(params){
      return this.$q((resolve, reject) => {
        this.$http({
          method: 'GET',
          url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getRelatedPosts,
          cache : true,
          params: params
        }).then((response) => {
          resolve(response.data);
        }, (reason) => {
          reject(reason);
        });
      });
    }

    getPanelBlog(){
      return this.$q((resolve, reject) => {
        this.$http({
          method: 'GET',
          url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.getPanelBlog,
          cache : true
        }).then((response) => {
          resolve(response.data);
        }, (reason) => {
          reject(reason);
        });
      });
    }






}

BlogService.$inject = inject;

export default BlogService;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/blog/blog.service.js
 **/